// Copyright (c) 2017 Comsearch, Inc., All rights reserved
import React from 'react'
import { func, number } from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import moment from 'moment'
import { renewUserSession } from 'redux/modules/user'
import { hide } from 'react-notification-system-redux'
import { SESSION_TIMEOUT_WARNING_NOTIFICATION_ID } from './constants'

const btnClasses = `btn btn-sm hover-inverse white-space-nowrap padding-left-0 padding-right-0 width-40`

class Message extends React.Component {
  static propTypes = {
    hide: func.isRequired,
    renewUserSession: func.isRequired,
    timestamp: number.isRequired,
  }

  state = {
    message: null,
  }

  componentWillMount () {
    this.updateTimestamp()
    // creates a counter that counts down to log out time.
    // the timestamp in UI is rounded (eg 'a few seconds')
    // so we don't need to update this every second.
    // set to update every 30 seconds instead
    this.timeoutCounter = setInterval(() => {
      this.updateTimestamp()
    }, 30000)
  }

  componentWillUnmount () {
    clearInterval(this.timeoutCounter)
  }

  forceStaticMessage = message => {
    clearInterval(this.timeoutCounter)
    this.setState(() => ({ message }))
  }

  getRelativeTimeStamp = () => moment(this.props.timestamp).fromNow(true)

  updateTimestamp = () => {
    const t = this.getRelativeTimeStamp() //  the time stamp label, human readable
    const message = `Your session will expire in ${t}. To remain logged in, you must renew your session.`
    if (this.state.message !== message) {
      this.setState(() => ({ message }))
    }
  }

  hideMessage = () => {
    return this.props.hide(SESSION_TIMEOUT_WARNING_NOTIFICATION_ID)
  }

  renewSession = async () => {
    const {
      forceStaticMessage,
      hideMessage,
      props: { renewUserSession },
    } = this

    try {
      await renewUserSession()
      hideMessage()
    } catch (err) {
      console.warn(err)
      const error = (
        err.message ||
        'There was an error trying to update the user session. Please try again.'
      )
      forceStaticMessage(error)
    }
    return false
  }

  render () {
    const {
      hideMessage,
      renewSession,
      state: { message },
    } = this

    return (
      <div className={'display-flex flex-wrap-wrap justify-content-around'}>
        <p
          className={'margin-bottom-1 width-100'}>
          {message}
        </p>
        <button
          className={`${btnClasses} bg-orange`}
          onClick={renewSession}>
          {'Renew Session'}
        </button>
        <button
          className={`${btnClasses} bg-grey-blue`}
          onClick={hideMessage}>
          {'Dismiss'}
        </button>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    hide,
    renewUserSession,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(Message)
